<template>
  <div class="focused-panel">
    <div class="d-flex seismic-line-rx-toolbar">
      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create seismic line" :pressed.sync="addEnabled" variant="primary">
        <icon scale=".6" name="plus"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select seismic line" :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>


      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit seismic line geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled"
             variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit seismic line attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled"
             variant="primary">
        <icon scale=".6" name="pencil-alt"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete seismic line" :disabled="!wellFeatureSelected"
             variant="primary">
        <icon scale=".6" name="times"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" :pressed.sync="ldEnabled" v-b-tooltip.hover.auto title="Load dependant layers"
             variant="primary">
        <icon scale=".6" name="link"/>
      </b-btn>

    </div>

    <b-modal v-model="showForm" no-close-on-backdrop no-close-on-esc>
      <div slot="modal-header">
        <label>{{formTitle}}</label>
      </div>
      <div class="p-2">
        <b-form>
          <b-form-group label="Ident:" label-for="seismic-line-sx-ident">
            <b-form-input id="seismic-line-sx-ident" v-model="wellAttrs['ident']" placeholder="Enter Seismic line ident"></b-form-input>
          </b-form-group>
        </b-form>
      </div>
      <div slot="modal-footer" class="designatron-modal-footer">
        <b-row>
          <b-col>
            <div role="group" class="btn-group">
              <b-btn size="sm" class="float-right" variant="primary" @click="close">
                Close
              </b-btn>
              <b-btn size="sm" :disabled="featureLock" class="float-right" variant="success" @click="onOK">
                Save
              </b-btn>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>


  </div>
</template>

<script>


  import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
  import Draw from 'ol/interaction/Draw'
  import Snap from 'ol/interaction/Snap'
  import bezierCurve from '@turf/bezier-spline'
  import GeoJSON from 'ol/format/GeoJSON'
  import { LineString } from 'ol/geom'

  export default {
    name: 'seismic-line-rx-editor',
    components: {},
    mixins: [FeatureEditorMixin],
    data () {
      return {
        multiEdit: false,
        mergeEnabled: false,
        geomType: 'LineString',
        geometryName: 'geom',
        idName: 'gid',
        wellLayerName: 'v4:wardswell_rx_20230621',
        wellAttrs: {
          ident: '',
          comments: '',
          library_id: null,
          asset_tag: ''
        },
        schema: 'wardswell_rx_20230621',
        identState: null,
        initialIdent: null,
        hoverLock: false,
        lockable: true
      }
    },
    methods: {
      close(evt) {
        this.wellFeature = null
        this.showForm = false
        this.onCancel()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/SeismicLineRXEditor.vue